export enum PanelSectionTypeEnum {
  PetDetails,
  PetWeight,
  PetGrowthChart,
  PetDiagnosis,
  PetNutritionalAssessment,
}
